import React, { useEffect } from 'react';
import useStyles from '../styles';
import { CustomRadioButton } from '../../../../../../Components';
import { Box } from '@material-ui/core';
function CPP_BI_NonGCCbuyers({ translate, selected, setSelected, handleSelectedChange, safeHandleNonGCCBuyer }) {
  const styles = useStyles();
  return (
    <>
      <Box className={styles.CPP_BI_NonGCCbuyersSectionWrapper}>
        <Box>
          <span className={styles.CPP_fieldLabel}>
            {translate('available-for-non-GCC-buyer')}
          </span>
        </Box>
        <Box className={styles.CPP_BI_NonGCCbuyersRadioWrapper}>
          <CustomRadioButton
            checked={selected.availableForNonGCCBuyer === "Yes"}
            onChange={(event) => {
              handleSelectedChange('availableForNonGCCBuyer', "Yes");
            }}
            label={translate('yes')}
            value="Yes"
          />
          <CustomRadioButton
            label={translate('no')}
            value="No"
            checked={selected.availableForNonGCCBuyer === "No"}
            onChange={(event) => {
              handleSelectedChange('availableForNonGCCBuyer', "No");
            }}
          />
        </Box>
      </Box>
    </>
  );
}

export default CPP_BI_NonGCCbuyers;
